import { Column, IHeaderParams } from 'ag-grid-community'
import {
  Divider,
  FormControl,
  FormControlLabel,
  Popover,
  PopoverProps,
  Radio,
  RadioGroup,
  Theme,
  ThumbtackIcon,
  Typography,
  makeStyles,
  useTheme,
} from '@forgeglobal/design-framework'
import { StyleDefaults } from 'isolated-design-library/ThemeProvider'

import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    boxShadow: '0px 2px 16px 0px rgba(153, 155, 168, 0.2)',
    minWidth: 220,
    transform: 'scale(1, 1) translateZ(0px) translateY(2px) !important',
    '& > *': {
      paddingTop: 0,
    },
  },
  header: {
    padding: theme.spacing(3, 2, 2.5),
    display: 'flex',
    alignItems: 'baseline',
    color: theme.palette.secondary.main,
  },
  headerIcon: {
    fontSize: 20,
    paddingRight: theme.spacing(2),
  },
  formLabel: {
    marginLeft: 0,
  },
  label: {
    color: StyleDefaults.textDark,
    fontSize: 13,
    fontWeight: 400,
  },
  radio: {
    padding: theme.spacing(1.5),
  },
}))

export const PinnedMenu = (props: PopoverProps & { title: string; params: IHeaderParams }) => {
  const styles = useStyles()
  const theme = useTheme()

  const setRadio = (pinned: string) => {
    props.params.columnApi && props.params.columnApi.setColumnPinned(props.params.column, pinned)
  }

  return (
    <Popover
      classes={{ paper: styles.wrapper }}
      keepMounted
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      transitionDuration={0}
      {...props}>
      <div className={styles.header}>
        <ThumbtackIcon className={styles.headerIcon} />
        <Typography variant="h6" color="secondary">
          {props.title}
        </Typography>
      </div>
      <Divider />
      <FormControl component="fieldset" style={{ width: '100%', padding: theme.spacing(1.5, 1) }}>
        <RadioGroup
          name="pin"
          value={props.params.column.getPinned() || ''}
          onChange={e => setRadio((e.target as HTMLInputElement).value)}>
          <FormControlLabel
            classes={{ root: styles.formLabel, label: styles.label }}
            value={Column.PINNED_LEFT}
            control={<Radio classes={{ root: styles.radio }} />}
            label="Left"
          />
          <FormControlLabel
            classes={{ root: styles.formLabel, label: styles.label }}
            value={Column.PINNED_RIGHT}
            control={<Radio classes={{ root: styles.radio }} />}
            label="Right"
          />
          <FormControlLabel
            classes={{ root: styles.formLabel, label: styles.label }}
            value={''}
            control={<Radio classes={{ root: styles.radio }} />}
            label="Not pinned"
          />
        </RadioGroup>
      </FormControl>
    </Popover>
  )
}
